import { OssObjectStorageService } from '@ys/crm-api'

import { getConfigOne, postConfigUpdate } from '@/api/crm/config'

export const providerApi = {
  getTableColumnConfig: getConfigOne,
  updateTableColumnConfig: postConfigUpdate,
  upload: async (...args) => (await OssObjectStorageService.postUploadFile(...args)).data.data,
}
